import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectSuburbanHouseTypeFilter } from 'shared/selectors/advancedFilters';
import { trackHouseTypeChoice } from './tracking';

export const SuburbanHouseTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectSuburbanHouseTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleSuburbanHouseTypeChange = useCallback(
    (newValue: boolean | null) => {
      onChange({ action: 'setIsDacha', arguments: [newValue] });

      trackHouseTypeChoice(newValue);
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleSuburbanHouseTypeChange} />
    </AdvancedFilterRow>
  );
};
